import { LegalDocumentType } from 'generated/graphql'

export const DOCUMENT_TYPE_OPTIONS = [
  { value: LegalDocumentType.TermsAndConditions, label: 'Terms & Conditions' },
  { value: LegalDocumentType.PrivacyPolicy, label: 'Privacy Policy' },
  { value: LegalDocumentType.CommercialTerms, label: 'Commercial Terms & Conditions' },
] as const

export const DOCUMENT_TYPE_LABELS: Record<string, string> = {
  [LegalDocumentType.TermsAndConditions]: 'Terms & Conditions',
  [LegalDocumentType.PrivacyPolicy]: 'Privacy Policy',
  [LegalDocumentType.CommercialTerms]: 'Commercial Terms & Conditions',
}

export const DOCUMENT_TYPE_FILTER_OPTIONS = [
  { value: '', label: 'All Types' },
  ...DOCUMENT_TYPE_OPTIONS,
]

export const ACCEPTED_FILE_TYPES = '.docx'
